var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareFinishLater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Clock_Line",
    "data-name": "icons/Clock/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.5,18.9a8.4,8.4,0,1,0-8.4-8.4A8.4,8.4,0,0,0,10.5,18.9Zm0,2.1A10.5,10.5,0,1,0,0,10.5,10.5,10.5,0,0,0,10.5,21Z",
    fill: "#2148ff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M1.228,0A1.167,1.167,0,0,1,2.448,1.105V6.174L5.142,8.613a1.033,1.033,0,0,1,0,1.563,1.313,1.313,0,0,1-1.726,0L.365,7.413c-.229-.207-.268.8-.358-.782s0-5.526,0-5.526S.554,0,1.228,0Z",
    transform: "translate(9 4)",
    fill: "#2148ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFinishLater);
export default __webpack_public_path__ + "static/media/shareFinishLater.3f2b5074f17ff824d3a45561f65bde78.svg";
export { ForwardRef as ReactComponent };